/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import "./ToastStyling.scss";
import * as React from "react";
import { Transition } from "react-transition-group";
import { Close, ErrorHollow, InfoHollow, SuccessHollow, } from "../../images/components";
/**
 * Generic Toast Notification Component
 * +++++
 * <Toast type="persisting" text="Job processing completed." category="success" link={{url:() => {alert("Link callback")}, title:"View the report"}} />
 * <Toast type="temporary" text="Processing completed." category="success" />
 * <Toast type="persisting" text="Bacon ipsum dolor amet shoulder andouille meatball meatloaf chicken pork loin alcatra boudin pig beef ribs. Short loin short ribs buffalo shankle, jerky fatback leberkas meatball boudin. Kevin meatloaf flank pancetta, picanha tail kielbasa salami ham hock sirloin cow frankfurter capicola. Jowl shankle short ribs rump shank ribeye, frankfurter sausage." category="informational" link={{url:"http://ux.bentley.com/bwc/react/", title:"View"}} />
 * <Toast type="temporary" text="26 files are available for synchonization." category="informational" />
 * <Toast type="persisting" text="Job processing error." category="error" />
 */
export class Toast extends React.Component {
    constructor(props) {
        super(props);
        /**
         * Close the Toast Notification
         */
        this.close = () => {
            this.clearCloseTimeout();
            this.setState({
                isVisible: false,
            });
        };
        this.state = {
            height: 0,
            isVisible: true,
        };
        this.closeTimeout = null;
        this.close = this.close.bind(this);
        this.setCloseTimeout = this.setCloseTimeout.bind(this);
        this.onRef = this.onRef.bind(this);
    }
    render() {
        const { text, category, type, hasCloseButton, link } = this.props;
        return (React.createElement(Transition, { timeout: 240, in: this.state.isVisible, appear: true, unmountOnExit: true, onExited: this.props.onRemove }, (state) => (React.createElement("div", { className: `itwin-toast-all itwin-toast-${state}`, style: {
                height: this.state.height,
                marginBottom: this.state.isVisible ? "0" : -this.state.height,
            } },
            React.createElement("div", { ref: this.onRef, style: { padding: "0px 16px 16px 16px" } },
                React.createElement("div", { className: `itwin-toast-${category}` },
                    React.createElement("div", { className: "status-icon-container" },
                        React.createElement("div", { className: "status-icon-background" }, this.getCategoryIcon())),
                    React.createElement("div", { className: "message" }, text),
                    link && (React.createElement("div", { className: "link" }, typeof link.url === "string" ? (React.createElement("a", { href: link.url, target: "_blank", rel: "noopener noreferrer" }, link.title)) : (React.createElement("a", { onClick: link.url }, link.title)))),
                    (type === "persisting" ||
                        (type === "temporary" && hasCloseButton)) && (React.createElement("div", { className: "close-icon-container" },
                        React.createElement(Close, { className: "close-icon", onClick: this.close })))))))));
    }
    componentDidMount() {
        if (this.props.type === "temporary" && this.props.duration) {
            this.setCloseTimeout(this.props.duration);
        }
        else if (this.props.type === "temporary") {
            this.setCloseTimeout();
        }
    }
    componentWillUnmount() {
        this.clearCloseTimeout();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isVisible !== this.props.isVisible) {
            this.setState({
                isVisible: this.props.isVisible,
            });
        }
    }
    /**
     * Category Management Function for proper Notification Icon
     * Return the Status Icon according to the category prop
     */
    getCategoryIcon() {
        if (this.props.category === "success") {
            return React.createElement(SuccessHollow, { className: "status-icon" });
        }
        else if (this.props.category === "informational") {
            return React.createElement(InfoHollow, { className: "status-icon" });
        }
        else {
            return React.createElement(ErrorHollow, { className: "status-icon" });
        }
    }
    /**
     * Set the Timer to close the Toast Notification after 7 seconds
     */
    setCloseTimeout(timeout = 7000) {
        this.closeTimeout = setTimeout(() => {
            this.close();
        }, timeout);
    }
    /**
     * Remove the Timer to close the Toast Notification (if its exists)
     */
    clearCloseTimeout() {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
        }
    }
    onRef(ref) {
        if (ref) {
            const { height } = ref.getBoundingClientRect();
            this.setState({
                height,
            });
        }
    }
}
export default Toast;
